// extracted by mini-css-extract-plugin
export default {"panel":"payment-method-panel_panel__HUzRm","panel--primary":"payment-method-panel_panel--primary__isoSw","panel--secondary":"payment-method-panel_panel--secondary__Ub9f-"};